"use strict";

var _defineProperty = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var log = require("loglevel");

var eventemitter3_1 = require("eventemitter3");

var utils_1 = require("../../src/utils");

var ethers_1 = require("ethers");

var bigNumberify = ethers_1.utils.bigNumberify;
var mockDomainBudget = {
  hubAddress: 'mock.hub.com',
  domain: 'mock.web3torrent.com',
  budgets: [{
    token: '0x0',
    availableReceiveCapacity: '0x5000000',
    availableSendCapacity: '0x3000000',
    channels: []
  }]
};

var FakeChannelProvider = /*#__PURE__*/function () {
  function FakeChannelProvider() {
    var _this = this;

    _classCallCheck(this, FakeChannelProvider);

    this.events = new eventemitter3_1.EventEmitter();
    this.url = '';
    this.playerIndex = {};
    this.opponentIndex = {};
    this.internalAddress = ethers_1.Wallet.createRandom().address;
    this.opponentAddress = {};
    this.latestState = {};
    this.budget = mockDomainBudget;

    this.on = function (method, params) {
      return _this.events.on(method, params);
    };

    this.off = function (method, params) {
      return _this.events.off(method, params);
    };
  }

  _createClass(FakeChannelProvider, [{
    key: "mountWalletComponent",
    value: function mountWalletComponent(url) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.url = url || '';
                this.signingAddress = this.getAddress();
                this.walletVersion = 'FakeChannelProvider@VersionTBD';
                this.destinationAddress = '0xEthereumAddress';

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "enable",
    value: function enable() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _ref, signingAddress, destinationAddress, walletVersion;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.send({
                  method: 'EnableEthereum',
                  params: {}
                });

              case 2:
                _ref = _context2.sent;
                signingAddress = _ref.signingAddress;
                destinationAddress = _ref.destinationAddress;
                walletVersion = _ref.walletVersion;
                this.signingAddress = signingAddress;
                this.destinationAddress = destinationAddress;
                this.walletVersion = walletVersion;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "send",
    value: function send(request) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = request.method;
                _context3.next = _context3.t0 === 'CreateChannel' ? 3 : _context3.t0 === 'PushMessage' ? 4 : _context3.t0 === 'GetWalletInformation' ? 5 : _context3.t0 === 'EnableEthereum' ? 5 : _context3.t0 === 'JoinChannel' ? 6 : _context3.t0 === 'GetState' ? 7 : _context3.t0 === 'UpdateChannel' ? 8 : _context3.t0 === 'CloseChannel' ? 9 : _context3.t0 === 'ApproveBudgetAndFund' ? 10 : _context3.t0 === 'CloseAndWithdraw' ? 11 : _context3.t0 === 'GetBudget' ? 12 : 13;
                break;

              case 3:
                return _context3.abrupt("return", this.createChannel(request.params));

              case 4:
                return _context3.abrupt("return", this.pushMessage(request.params));

              case 5:
                return _context3.abrupt("return", {
                  signingAddress: this.getAddress(),
                  destinationAddress: '0xEthereumAddress',
                  walletVersion: 'FakeChannelProvider@VersionTBD'
                });

              case 6:
                return _context3.abrupt("return", this.joinChannel(request.params));

              case 7:
                return _context3.abrupt("return", this.getState(request.params));

              case 8:
                return _context3.abrupt("return", this.updateChannel(request.params));

              case 9:
                return _context3.abrupt("return", this.closeChannel(request.params));

              case 10:
                return _context3.abrupt("return", this.approveBudgetAndFund(request.params));

              case 11:
                return _context3.abrupt("return", this.closeAndWithdraw(request.params));

              case 12:
                return _context3.abrupt("return", this.getBudget(request.params));

              case 13:
                return _context3.abrupt("return", Promise.reject("No callback available for ".concat(request.method)));

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      return Promise.resolve('success');
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      return Promise.resolve(true);
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this.latestState = Object.assign(Object.assign({}, this.latestState), _defineProperty({}, state.channelId, state));
    }
  }, {
    key: "setAddress",
    value: function setAddress(address) {
      this.internalAddress = address;
    }
  }, {
    key: "updatePlayerIndex",
    value: function updatePlayerIndex(channelId, playerIndex) {
      if (this.playerIndex[channelId] === undefined) {
        this.playerIndex[channelId] = playerIndex;
        this.opponentIndex[channelId] = playerIndex == 1 ? 0 : 1;
      }
    }
  }, {
    key: "getAddress",
    value: function getAddress() {
      if (this.internalAddress === undefined) {
        throw Error('No address has been set yet');
      }

      return this.internalAddress;
    }
  }, {
    key: "getPlayerIndex",
    value: function getPlayerIndex(channelId) {
      if (this.playerIndex === undefined) {
        throw Error("This client does not have its player index set yet");
      }

      return this.playerIndex[channelId];
    }
  }, {
    key: "getOpponentIndex",
    value: function getOpponentIndex(channelId) {
      if (this.opponentIndex[channelId] === undefined) {
        throw Error("This client does not have its opponent player index set yet");
      }

      return this.opponentIndex[channelId];
    }
  }, {
    key: "verifyTurnNum",
    value: function verifyTurnNum(channelId, turnNum) {
      var currentTurnNum = bigNumberify(turnNum);

      if (currentTurnNum.mod(2).eq(this.getPlayerIndex(channelId))) {
        return Promise.reject("Not your turn: currentTurnNum = ".concat(currentTurnNum, ", index = ").concat(this.playerIndex[channelId]));
      }

      return Promise.resolve();
    }
  }, {
    key: "findChannel",
    value: function findChannel(channelId) {
      if (!Object.keys(this.latestState).includes(channelId)) {
        throw Error("Channel doesn't exist with channelId '".concat(JSON.stringify(channelId, null, 4), "'"));
      }

      return this.latestState[channelId];
    }
  }, {
    key: "createChannel",
    value: function createChannel(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var participants, allocations, appDefinition, appData, channel;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                participants = params.participants;
                allocations = params.allocations;
                appDefinition = params.appDefinition;
                appData = params.appData;
                channel = {
                  participants: participants,
                  allocations: allocations,
                  appDefinition: appDefinition,
                  appData: appData,
                  channelId: utils_1.calculateChannelId(participants, appDefinition),
                  turnNum: bigNumberify(0).toString(),
                  status: 'proposed'
                };
                this.updatePlayerIndex(channel.channelId, 0);
                this.setState(channel);
                this.internalAddress = channel.participants[0].participantId;
                this.opponentAddress[channel.channelId] = channel.participants[1].participantId;
                this.notifyOpponent(channel, 'CreateChannel');
                return _context4.abrupt("return", channel);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "joinChannel",
    value: function joinChannel(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var channelId, latestState;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                channelId = params.channelId;
                latestState = this.findChannel(channelId);
                this.updatePlayerIndex(channelId, 1);
                log.debug("Player ".concat(this.getPlayerIndex(channelId), " joining channel ").concat(channelId));
                _context5.next = 6;
                return this.verifyTurnNum(channelId, latestState.turnNum);

              case 6:
                this.setState(Object.assign(Object.assign({}, latestState), {
                  turnNum: bigNumberify(3).toString(),
                  status: 'running'
                }));
                this.opponentAddress[channelId] = latestState.participants[0].participantId;
                this.notifyOpponent(this.latestState[channelId], 'joinChannel');
                return _context5.abrupt("return", this.latestState[channelId]);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getState",
    value: function getState(_ref2) {
      var channelId = _ref2.channelId;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.findChannel(channelId));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "updateChannel",
    value: function updateChannel(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var channelId, participants, allocations, appData, latestState, nextState;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                channelId = params.channelId;
                participants = params.participants;
                allocations = params.allocations;
                appData = params.appData;
                log.debug("Player ".concat(this.getPlayerIndex(channelId), " updating channel ").concat(channelId));
                latestState = this.findChannel(channelId);
                nextState = Object.assign(Object.assign({}, latestState), {
                  participants: participants,
                  allocations: allocations,
                  appData: appData
                });
                _context7.next = 9;
                return this.verifyTurnNum(channelId, latestState.turnNum);

              case 9:
                nextState.turnNum = bigNumberify(latestState.turnNum).add(1).toString();
                log.debug("Player ".concat(this.getPlayerIndex(channelId), " updated channel to turnNum ").concat(nextState.turnNum));
                this.setState(nextState);
                this.notifyOpponent(this.latestState[channelId], 'ChannelUpdate');
                return _context7.abrupt("return", this.latestState[channelId]);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "closeChannel",
    value: function closeChannel(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var latestState, turnNum, status;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                latestState = this.findChannel(params.channelId);
                _context8.next = 3;
                return this.verifyTurnNum(params.channelId, latestState.turnNum);

              case 3:
                turnNum = bigNumberify(latestState.turnNum).add(1).toString();
                status = 'closing';
                this.setState(Object.assign(Object.assign({}, latestState), {
                  turnNum: turnNum,
                  status: status
                }));
                log.debug("Player ".concat(this.getPlayerIndex(params.channelId), " updated channel to status ").concat(status, " on turnNum ").concat(turnNum));
                this.notifyOpponent(this.latestState[params.channelId], 'ChannelUpdate');
                return _context8.abrupt("return", this.latestState[params.channelId]);

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "notifyAppChannelUpdated",
    value: function notifyAppChannelUpdated(data) {
      this.events.emit('ChannelUpdated', data);
    }
  }, {
    key: "notifyAppBudgetUpdated",
    value: function notifyAppBudgetUpdated(data) {
      this.events.emit('BudgetUpdated', data);
    }
  }, {
    key: "notifyOpponent",
    value: function notifyOpponent(data, notificationType) {
      log.debug("".concat(this.getPlayerIndex(data.channelId), " notifying opponent ").concat(this.getOpponentIndex(data.channelId), " about ").concat(notificationType));
      var sender = this.internalAddress;
      var recipient = this.opponentAddress[data.channelId];

      if (!recipient) {
        throw Error("Cannot notify opponent - opponent address not set");
      }

      this.events.emit('MessageQueued', {
        sender: sender,
        recipient: recipient,
        data: data
      });
    }
  }, {
    key: "isChannelResult",
    value: function isChannelResult(data) {
      return typeof data === 'object' && data != null && 'turnNum' in data;
    }
  }, {
    key: "pushMessage",
    value: function pushMessage(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var channel, turnNum;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!this.isChannelResult(params.data)) {
                  _context9.next = 15;
                  break;
                }

                this.setState(params.data);
                this.notifyAppChannelUpdated(this.latestState[params.data.channelId]);
                channel = params.data;
                turnNum = bigNumberify(channel.turnNum).add(1).toString();
                _context9.t0 = params.data.status;
                _context9.next = _context9.t0 === 'proposed' ? 8 : _context9.t0 === 'closing' ? 10 : 14;
                break;

              case 8:
                this.events.emit('ChannelProposed', channel);
                return _context9.abrupt("break", 15);

              case 10:
                this.setState(Object.assign(Object.assign({}, this.latestState[channel.channelId]), {
                  turnNum: turnNum,
                  status: 'closed'
                }));
                this.notifyOpponent(this.latestState[channel.channelId], 'ChannelUpdate');
                this.notifyAppChannelUpdated(this.latestState[channel.channelId]);
                return _context9.abrupt("break", 15);

              case 14:
                return _context9.abrupt("break", 15);

              case 15:
                return _context9.abrupt("return", {
                  success: true
                });

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "approveBudgetAndFund",
    value: function approveBudgetAndFund(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.budget = {
                  hubAddress: params.hub.signingAddress,
                  domain: 'localhost',
                  budgets: [{
                    token: '0x0',
                    availableReceiveCapacity: params.requestedReceiveCapacity,
                    availableSendCapacity: params.requestedSendCapacity,
                    channels: []
                  }]
                };
                this.notifyAppBudgetUpdated(this.budget);
                return _context10.abrupt("return", this.budget);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "closeAndWithdraw",
    value: function closeAndWithdraw(_params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", {
                  success: true
                });

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
    }
  }, {
    key: "getBudget",
    value: function getBudget(_params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", this.budget);

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }]);

  return FakeChannelProvider;
}();

exports.FakeChannelProvider = FakeChannelProvider;